module.exports = __webpack_public_path__ + "img/lianghao.d38b057f.png";